import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useStockAlerts = () => useQuery({
    queryKey: ['stock-alerts'],
    queryFn: async () => {
        const { data } = await API.get('/stock/alerts')
        return data
    },
    staleTime: 5 * 60 * 1000,
})

export default useStockAlerts
